import React from 'react';
import PropTypes from 'prop-types';
import cls from 'classnames/bind';

import SelectArrowIcon from '@ott/icon-select-arrow';
import DropdownArrowIcon from '@ott/icon-dropdown-arrow';

import s from './DropdownTrigger.scss';

const cx = cls.bind(s);

class DropdownTrigger extends React.PureComponent {
  static propTypes = {
    size: PropTypes.string,
    label: PropTypes.node,
    value: PropTypes.node,
    disabled: PropTypes.bool,
    childrenClassNames: PropTypes.shape({
      wrapper: PropTypes.string,
      label: PropTypes.string,
      arrowContainer: PropTypes.string,
    }),
  };

  static defaultProps = {
    disabled: false,
    childrenClassNames: {
      wrapper: '',
      label: '',
      arrowContainer: '',
    },
  };

  constructor(props, ctx) {
    super(props, ctx);
  }

  render() {
    const {
      size,
      label,
      value,
      withArrow,
      withPadding,
      withBorder,
      withBorderRadius,
      isOpen,
      isError,
      renderTriggerValue,
      initialActiveIdx,
      renderOption,
      renderGroup,
      groupStarterKey,
      items,
      onOptionSelect,
      skipActive,
      isStaticPosition,
      align,
      placeholderDisposable,
      childrenClassNames,
      initialValue,
      autoSelectIfOne,
      optionalButtonHandler,
      buttonContent,
      disabled,
      isTouchDevice,
      ...rest
    } = this.props;

    // TODO: <div><SelectArrowIcon w={12} h={8} className={cx('arrow')} /></div> &&
    // <div><DropdownArrowIcon className={cx('arrow')} /></div> обернуты в div, чтобы устранить баг с выравниванием
    // в iOS-10, нужно выпилить, когда доля iOS-10 будет небольшой

    return (
      <button
        {...rest}
        type="button"
        tabIndex="0"
        className={cx('DropdownTrigger', childrenClassNames.trigger, {
          'DropdownTrigger--isSmall': size === 'small',
          'DropdownTrigger--isMedium': size === 'medium',
          'DropdownTrigger--withoutArrow': !withArrow,
          'DropdownTrigger--withoutPadding': !withPadding,
          'DropdownTrigger--withoutBorder': !withBorder,
          'DropdownTrigger--withoutBorderRadius': !withBorderRadius,
          'DropdownTrigger--isOpen': isOpen,
          'DropdownTrigger--isError': isError,
          'DropdownTrigger--isDisabled': disabled,
        })}
        disabled={disabled}
      >
        <div className={cx('wrap', childrenClassNames.wrapper)}>
          <div className={cx('label', childrenClassNames.label)}>{label}</div>
          <div className={cx('value')}>{value}</div>
        </div>

        {size === 'basic' ? (
          <div className={cx(childrenClassNames.arrowContainer)}>
            <SelectArrowIcon w={12} h={8} className={cx('arrow')} />
          </div>
        ) : (
          <div className={cx(childrenClassNames.arrowContainer)}>
            <DropdownArrowIcon className={cx('arrow')} />
          </div>
        )}
      </button>
    );
  }
}

export default DropdownTrigger;
